<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/2umF6P/tc-custom/9781488010873.jpg?1720639549433" alt="This image is the cover for the book Hot Pursuit, Hotshot Heroes"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Hot Pursuit, Hotshot Heroes
      </h1>
      <p class="bookDescription body article font2">
        <b>Sparks fly between an arson investigator and a sexy firefighter as they work together to stop a madman in this scorching hot romantic suspense.</b><br/><br/>For Braden Zimmer, leading his team of Hotshot firefighters isn’t just about being the best—it’s about sensing when a fire is coming. And a scorcher is <i>definitely</i> on its way. Maybe it’s from the dangerous arsonist who’s targeted him. Or maybe it has something to do with the sexy little investigator who’s been sent to protect Braden . . . <br/><br/>Sam McRooney may be tiny and blonde but she doesn’t mess around. Braden is in serious danger, and she’s not about to jeopardize his life—even if he <i>is</i> hot enough to leave scorch marks on her libido. But with the arsonist growing bolder by the day, getting too close to this hunky Hotshot won’t just get her burned . . . it could get her killed.
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Lisa Childs
      </h2>
      
      <p class="authorDescription body article">New York Times &amp; USA Today bestselling, award-winning author Lisa Childs has written more than 85 novels. Published in 20 countries, she&#39;s also appeared on the Publisher&#39;s Weekly, Barnes &amp; Nobles and Nielsen Top 100 bestseller lists. Lisa writes contemporary romance, romantic suspense, paranormal and women&#39;s fiction. She&#39;s a wife, mom, bonus mom, an avid reader and a less avid runner. Readers can reach her through Facebook or her website www.lisachilds.com</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Harlequin
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?bc27b2c4